var React = require('react');

function FlagOfUnitedArabEmirates (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_580_78)","key":0},[React.createElement("rect",{"width":"30","height":"20","fill":"white","key":0}),React.createElement("path",{"d":"M30 0H0V20H30V0Z","fill":"#00732F","key":1}),React.createElement("path",{"d":"M30 6H8V13H30V6Z","fill":"white","key":2}),React.createElement("path",{"d":"M30 13H8V20H30V13Z","fill":"black","key":3}),React.createElement("path",{"d":"M8 0H0V20H8V0Z","fill":"#FF0000","key":4})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_580_78"},React.createElement("rect",{"width":"30","height":"20","fill":"white"})))]);
}

FlagOfUnitedArabEmirates.defaultProps = {"width":"30","height":"20","viewBox":"0 0 30 20","fill":"none"};

module.exports = FlagOfUnitedArabEmirates;

FlagOfUnitedArabEmirates.default = FlagOfUnitedArabEmirates;
